export const uffRadii = {
  H: 1.286,
  He: 1.052,
  Li: 1.092,
  Be: 1.223,
  B: 1.819,
  C: 1.715,
  N: 1.63,
  O: 1.559,
  F: 1.498,
  Ne: 1.445,
  Na: 1.329,
  Mg: 1.346,
  Al: 2.004,
  Si: 1.913,
  P: 1.847,
  S: 1.797,
  Cl: 1.758,
  Ar: 1.723,
  K: 1.698,
  Ca: 1.514,
  Sc: 1.468,
  Ti: 1.414,
  V: 1.4,
  Cr: 1.347,
  Mn: 1.319,
  Fe: 1.297,
  Co: 1.279,
  Ni: 1.262,
  Cu: 1.557,
  Zn: 1.231,
  Ga: 1.952,
  Ge: 1.907,
  As: 1.884,
  Se: 1.873,
  Br: 1.866,
  Kr: 1.845,
  Rb: 1.833,
  Sr: 1.622,
  Y: 1.49,
  Zr: 1.392,
  Nb: 1.41,
  Mo: 1.36,
  Tc: 1.335,
  Ru: 1.32,
  Rh: 1.305,
  Pd: 1.291,
  Ag: 1.402,
  Cd: 1.269,
  In: 1.988,
  Sn: 1.956,
  Sb: 1.969,
  Te: 1.991,
  I: 2.005,
  Xe: 1.962,
  Cs: 2.012,
  Ba: 1.649,
  La: 1.569,
  Ce: 1.584,
  Pr: 1.606,
  Nd: 1.592,
  Pm: 1.58,
  Sm: 1.568,
  Eu: 1.556,
  Gd: 1.5,
  Tb: 1.537,
  Dy: 1.527,
  Ho: 1.519,
  Er: 1.511,
  Tm: 1.503,
  Yb: 1.494,
  Lu: 1.621,
  Hf: 1.399,
  Ta: 1.412,
  W: 1.367,
  Re: 1.316,
  Os: 1.39,
  Ir: 1.265,
  Pt: 1.227,
  Au: 1.467,
  Hg: 1.205,
  Tl: 1.936,
  Pb: 1.914,
  Bi: 1.947,
  Po: 2.098,
  At: 2.116,
  Rn: 2.123,
  Fr: 2.183,
  Ra: 1.638,
  Ac: 1.549,
  Th: 1.513,
  Pa: 1.525,
  U: 1.512,
  Np: 1.525,
  Pu: 1.525,
  Am: 1.506,
  Cm: 1.482,
  Bk: 1.487,
  Cf: 1.476,
  Es: 1.47,
  Fm: 1.464,
  Md: 1.458,
  No: 1.447,
  Lr: 1.441,
};
